const videoBlock = document.querySelectorAll('.js-YTvideo-block')
const playButtons = document.querySelectorAll('.js-play-button ')
const videoContent = document.querySelectorAll('.js-video-content ')
const closeButton = document.querySelectorAll('.js-close ')
const youtubePlayers = []
export default () => {
  resetAllVideo()
  if (videoBlock.length) {
    loadYoutubeApi()
  }
  if (playButtons.length) {
    ;[...playButtons].forEach(el => {
      el.addEventListener('click', () => {
        const iframeTarget = el.getAttribute('data-iframe-id')
        stopAllVideos()
        playVideo(iframeTarget, el)
      })
    })
    ;[...closeButton].forEach(el => {
      el.addEventListener('click', () => {
        const iframeTarget = el.getAttribute('data-iframe-id')
        stopVideo(iframeTarget)
        videoPause()
      })
    })
  }
}
function playVideo(iframeTarget, overlay) {
  setClassesForPlaying(iframeTarget, overlay)
  ;[...youtubePlayers].forEach(el => {
    if (el.iframeID === iframeTarget) {
      setTimeout(() => {
        el.player.playVideo()
        el.player.unMute()
      }, 250)
    }
  })
}
function stopVideo(iframeTarget) {
  ;[...youtubePlayers].forEach(el => {
    if (el.iframeID === iframeTarget) {
      setTimeout(() => {
        el.player.stopVideo()
        el.player.unMute()
      }, 250)
    }
  })
}
function stopAllVideos() {
  resetAllVideo()
  ;[...youtubePlayers].forEach(el => {
    setTimeout(() => {
      el.player.stopVideo()
      el.player.unMute()
    }, 250)
  })
}
function loadYoutubeApi() {
  var tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  var firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}
window.onYouTubeIframeAPIReady = () => {
  ;[...videoBlock].forEach(el => {
    const youtubeVideoID = el.getAttribute('data-youtube-id')
    const iframeID = el.getAttribute('data-iframe-id')
    if (youtubeVideoID && iframeID) {
      youtubePlayers.push({
        iframeID: iframeID,
        containerID: el.id,
        player: createPlayer(iframeID, youtubeVideoID, 0),
        autoplay: 0
      })
    } else {
      console.error('YoutubeID or iframeID is not set')
    }
  })
}
function createPlayer(iframeID, youtubeVideoID, controls) {
  return new YT.Player(iframeID, {
    height: '390',
    width: '640',
    videoId: youtubeVideoID,
    playerVars: {
      enablejsapi: 0,
      controls: 1,
      rel: 0,
      autohide: 0,
      playsinline: 0,
      html5: 1,
      modestbranding: 1,
      color: 'white',
      iv_load_policy: 3
    },
    events: { onStateChange: onPlayerStateChange }
  })
}

function onPlayerStateChange(e) {
  let playerState = e.data
  switch (playerState) {
    case 0:
      //ending
      console.log(e)
      resetAllVideo()
      break
    case 1:
      //playing
      console.log(e)
      break
    case 2:
      //pause
      console.log(e)
      // videoPause ( )
      break
  }
}
function resetAllVideo() {
  if (videoBlock.length) {
    ;[...playButtons].forEach(el => {
      el.classList.add('c-video-block__play-button--show')
      el.classList.remove('c-video-block__play-button--hide')
    })
    if (videoContent.length) {
      ;[...videoContent].forEach(el => {
        el.style.marginBottom = '-' + el.clientHeight / 2.5 + 'px'
        el.classList.add('c-video-block__content-container--idle')
        el.classList.remove('c-video-block__content-container--active')
      })
    }
    ;[...closeButton].forEach(el => {
      el.classList.add('c-video-block__close--hide')
      el.classList.remove('c-video-block__close--show')
    })
  }
}
function videoPause() {
  if (videoBlock.length) {
    ;[...playButtons].forEach(el => {
      el.classList.add('c-video-block__play-button--show')
      el.classList.remove('c-video-block__play-button--hide')
    })
    if (videoContent.length) {
      ;[...videoContent].forEach(el => {
        el.style.marginBottom = '-' + el.clientHeight / 2.5 + 'px'
        el.classList.add('c-video-block__content-container--idle')
        el.classList.remove('c-video-block__content-container--active')
      })
    }
    ;[...closeButton].forEach(el => {
      el.classList.add('c-video-block__close--hide')
      el.classList.remove('c-video-block__close--show')
    })
  }
}
function setClassesForPlaying(iframeTarget, overlay) {
  //get elements en ID
  const contentID = overlay.getAttribute('data-content-id')
  const content = document.getElementById(contentID)
  const closeID = overlay.getAttribute('data-close-id')
  const close = document.getElementById(closeID)
  const playercontainer = document.getElementById(iframeTarget)
  //hide overlay
  overlay.classList.add('c-video-block__play-button--hide')
  overlay.classList.remove('c-video-block__play-button--show')
  //show iframe
  playercontainer.classList.remove('c-video-block__iframe--hide')
  playercontainer.classList.add('c-video-block__iframe--show')
  //show close
  close.classList.remove('c-video-block__close--hide')
  close.classList.add('c-video-block__close--show')
  //move content
  if (content) {
    content.classList.add('c-video-block__content-container--active')
    content.classList.remove('c-video-block__content-container--idle')
    content.style.marginBottom = 0
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/VideoBlock.js